import Olympic_Home from 'pages/Olympic/Home';
import Olympic_Practice from 'pages/Olympic/Practice';
import Olympic_Start from 'pages/Olympic/Start';
import Olympic_Result from 'pages/Olympic/Result';
import { administrators } from 'constants/auth';

export default [
  {
    path: '/olympic/practice',
    component: Olympic_Practice,
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
    users: administrators,
  },
  {
    path: '/exercise/examination/:examination/start/:index',
    component: Olympic_Start,
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
    users: administrators,
  },
  {
    path: '/exercise/examination/:examination/result',
    component: Olympic_Result,
    layout: '/lms',
    exact: true,
    roles: ['authenticated'],
    users: administrators,
  },
];
